import React from "react";
import { motion } from "framer-motion";
import { FlaskConical } from "lucide-react";
import IngredientCard from "./IngredientCard";

const a_span = (ing, i, hasPremium) => (ing.premium || (!hasPremium && i === 0) ? "md:col-span-2" : "");

export const ActivesSection = ({ sections = {}, actives = [], comboMap = {}, trademarks = [], flush = false }) => {
    if (!actives.length) return null;
    const hasPremium = actives.some((a) => a.premium);
    return (
        <section className={`bg-bg1 border-y border-white/10 py-12 md:py-16 ${flush ? "" : "mt-12 md:mt-16"}`} data-testid="actives-section">
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="mb-12 max-w-2xl">
                    <div className="eyebrow mb-3 flex items-center gap-2">
                        <FlaskConical className="w-3.5 h-3.5" /> Potent Actives
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl uppercase tracking-tight">
                        {sections.actives_title || `${actives.length} Potent Herbal Actives`}
                    </h2>
                    {sections.actives_subtitle && (
                        <p className="mt-5 text-zinc-400 leading-relaxed">{sections.actives_subtitle}</p>
                    )}
                </div>

                <div className="grid md:grid-cols-4 gap-4">
                    {actives.map((ing, i) => (
                        <motion.div
                            key={ing.id || ing.name}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: Math.min(i, 8) * 0.04 }}
                            className={a_span(ing, i, hasPremium)}
                        >
                            <IngredientCard
                                ingredient={ing}
                                combo={comboMap[ing.combo_id]}
                                index={i}
                                hero={!hasPremium && i === 0}
                                showDescription={false}
                                testId={`active-card-${i}`}
                            />
                        </motion.div>
                    ))}
                </div>

                {!!trademarks.length && (
                    <div className="mt-10 pt-6 border-t border-white/10" data-testid="trademark-strip">
                        <div className="mono text-[9px] tracking-[0.25em] text-zinc-500 mb-3">TRADEMARK CREDITS</div>
                        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2">
                            {trademarks.map((t, i) => (
                                <p key={i} className="text-[11px] text-zinc-500 leading-relaxed">{t}</p>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ActivesSection;
